import React from "react"
import { cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function DisclaimerRender(){

  const { getElementConfig }:any = useTemplatePreviewCtx()
  const config = getElementConfig("disclaimer")

  const outerStyling = useRenderStyling("mm-section w-full pl-2", "styleObj")
  const contentStyling = useRenderStyling("leading-snug", "styleObj")

  return(
    <div id="mm-disclaimer" {...outerStyling}>
      <p {...contentStyling}>Please be advised that the documents above illustrate an example of the customer journey. Information in this document is based on data held by the merchant and publicly available sources. If the information contained herein is illegible or if additional information is required, please contact us via fax at +1 707-340-7609.</p>
    </div>
  )
}